<desy-header
  [homepageRouterLink]="''"
  [noLogo]="false">
  <desy-header-navigation>
    <desy-header-navigation-item
      *ngFor="let item of menuItems"
      [routerLink]="item.link"
      [active]="isActive(item.link)">
      {{ item.label }}
    </desy-header-navigation-item>
  </desy-header-navigation>

  <desy-header-dropdown>
      {{ userName$ | async }}
    <desy-nav>
      <desy-nav-item [title]="'Cerrar sesión'" (clickEvent)="logout()">Cerrar sesión</desy-nav-item>
    </desy-nav>
  </desy-header-dropdown>
  <desy-header-offcanvas>
    <desy-header-offcanvas-button>Menú</desy-header-offcanvas-button>
    <desy-header-offcanvas-close-button>Cerrar menú</desy-header-offcanvas-close-button>
    <desy-content>
      <aside>
        <nav
          class="w-full p-2"
          aria-labelledby="menu-movil-title">
          <h2
            id="menu-movil-title"
            class="sr-only">
            Menú principal
          </h2>
          <desy-nav
            [idPrefix]="'nav-mobile-pages'"
            [ariaLabel]="'Lista de páginas'"
            [hasNav]="false">
            <desy-nav-item
              *ngFor="let item of menuItems"
              [routerLink]="item.link"
              [active]="isActive(item.link)">
              {{ item.label }}
            </desy-nav-item>
          </desy-nav>

          <h3 class="p-base text-base font-bold">Usuario/a: {{ userName$ | async }}</h3>
          <desy-nav
            [idPrefix]="'nav-mobile-user'"
            [ariaLabel]="'Lista de acciones de usuario'"
            [hasNav]="false">
            <desy-nav-item [title]="'Cerrar sesión'" (clickEvent)="onNavItemClick($event)">Cerrar sesión</desy-nav-item>
          </desy-nav>
        </nav>
      </aside>
    </desy-content>
  </desy-header-offcanvas>
</desy-header>
